<template lang="pug">
	.campaign-products.flex-col.space-large.align-center.center(:class="{ disabled: info.states.productsLoading || info.readonly }")
		.flex-row.space.wrap.align-center.center
			.product-category.flex-col.space.center.align-center(v-for="dapCategory in dapCategories", :class="{ selected: !!campaignProducts.find(f => f.DapCategory.Oid === dapCategory.Oid) }", @click="addProductCategory(dapCategory)")
				.flex-col
					fas(:icon="dapCategory.type.icon", size="xl")
					.flex-row.space
						fas(v-if="!!campaignProducts.find(f => f.DapCategory.Oid === dapCategory.Oid)", icon="check", size="lg")
						span {{dapCategory.Name}}
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import Loader from 'app-core/Loader.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import { DAP_CATEGORY_TYPES } from 'app-core/constants';
	import _ from 'lodash';

	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-products',
		components: {
			DxButton, DxTextBox, Loader, DxDateBox, Dropdown
		},
		props: ['info', 'active'],
		data() {
			return {
				dapCategoryTypes: DAP_CATEGORY_TYPES.toLocale('name', this),
				dapCategories: [],
				initialized: false
			};
		},
		computed: {
			campaign() {
				return this.info?.campaign;
			},
			campaignProducts() {
				return this.info?.campaignProducts;
			},
		},
		watch: {			
		},
		mounted() {
			if (__DEBUG__)
				window.campaignProducts = this;
			this.loadDapCategories();
		},
		methods: {
			loadDapCategories() {
				this.isLoading
				this.$Data.getExternalApi('Service/GetDapCategories').then(r => {
					this.dapCategories = _.orderBy(r.map(f => ({
						...f,
						type: this.dapCategoryTypes[f.Type]
					})) || [], ['Type', 'Name']);
				});
			},
			addProductCategory(dapCategory) {
				const exists = this.campaignProducts.find(f => f.DapCategory.Oid === dapCategory.Oid);
				if (exists) {
					this.$emit('show-product', exists)
				} else {
					this.$emit('new-product', dapCategory);
				}
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.campaign-products {
		min-height: 280px;

		.product-category {
			min-width: 180px;
			min-height: 180px;
			background: #ececec;
			margin: 4px;
			border-radius: 8px;
			border: 2px solid #ececec;
			font-size: 18px;
			font-weight: 100;
			-webkit-box-shadow: 2px 2px 13px 2px rgba(0,0,0,0.1);
			-moz-box-shadow: 2px 2px 13px 2px rgba(0,0,0,0.1);
			box-shadow: 2px 2px 13px 2px rgba(0,0,0,0.1);
			cursor: pointer;
			transition: 0.3s;
			transform: scale(1);
			padding: 20px;

			&:hover {
				border: 2px solid $base-accent;
				transform: scale(1.05);
			}

			&.selected {
				color: $base-accent;
			}
		}
	}
</style>
 